import { clsx } from 'clsx';
import { type ReactNode } from 'react';
import styles from './SectionsSwitch.scss';

interface SectionSwitchProps<T extends string> {
  options: T[];
  selectedOption: T;
  name: string;
  onSelected: (slide: T) => void;
  optionLabels?: Record<T, ReactNode>;
  className?: string;
}

const SectionsSwitch = <T extends string>({
  options,
  optionLabels,
  name,
  selectedOption,
  onSelected,
  className,
}: SectionSwitchProps<T>) => (
  <fieldset className={clsx(styles.slideControls, className)}>
    {Object.values(options).map((option) => (
      <label
        key={option}
        className={clsx(styles.button, option === selectedOption && styles.buttonSelected)}
        aria-selected={option === selectedOption}
      >
        <input
          type="radio"
          name={name}
          value={option}
          checked={option === selectedOption}
          onChange={() => {
            onSelected(option);
          }}
        />
        {optionLabels?.[option] || option}
      </label>
    ))}
  </fieldset>
);

export default SectionsSwitch;
